import { faFileCode, faCode } from "@fortawesome/free-solid-svg-icons";

export const ExportsData = [
    {
        id: 'areas-academicas',
        pathname: 'home',
        name: 'Áreas académicas',
        type: 'Componentes',
        icon: faCode,
        format: 'HTML, CSS, JS',
        desc: 'Código HTML correspondiente al componente de las áreas académicas y sus instituciones.'
    },
    {
        id: 'cursos-externos',
        pathname: 'external',
        name: 'Cursos externos',
        type: 'Componentes',
        icon: faCode,
        format: 'HTML, CSS, JS',
        desc: 'Código HTML correspondiente al componente que muestra un enlace a los cursos externos.'
    },
    {
        id: 'lista-cursos',
        pathname: 'page',
        name: 'Cursos por facultad',
        type: 'Páginas',
        icon: faFileCode,
        format: 'HTML, CSS, JS',
        desc: 'Código HTML correspondiente la página de la lista de cursos por facultad.'
    },
]